// On-device only history for the Free Tools. Nothing leaves the browser.
const KEY = "amd-tool-history";
const MAX = 20;

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function writeAll(obj) {
  try {
    localStorage.setItem(KEY, JSON.stringify(obj));
  } catch {
    /* storage unavailable — silently ignore */
  }
}

export function getToolHistory(slug) {
  return readAll()[slug] || [];
}

export function saveToolEntry(slug, value) {
  if (!slug || !value) return [];
  const all = readAll();
  const list = all[slug] || [];
  list.unshift({ ts: Date.now(), value });
  all[slug] = list.slice(0, MAX);
  writeAll(all);
  try {
    window.dispatchEvent(new CustomEvent("amd-tool-saved", { detail: { slug } }));
  } catch {
    /* no-op */
  }
  return all[slug];
}

export function clearToolHistory(slug) {
  const all = readAll();
  delete all[slug];
  writeAll(all);
  try {
    window.dispatchEvent(new CustomEvent("amd-tool-saved", { detail: { slug } }));
  } catch {
    /* no-op */
  }
}
